module.exports = __webpack_public_path__ + "img/重置密码.517bdae0.png";